import React from 'react';
import {
  Box,
  Button,
  IconButton,
  Icons,
  Modal,
  Text,
  useTheme,
} from '@ublend-npm/aulaui-core';
import {
  INBOX_CONVERSATION_ACTION_LEAVE_CONVERSATION_RESPONSIVE,
  INBOX_LEAVE_CONVERSATION_TITLE_RESPONSIVE,
} from '../../../../../constants/texts';

export const INBOX_LEAVE_CONVERSATION_QUESTION = (conversationTitle) => (
  <div>
    You will no longer be able to send or receive messages in{' '}
    <b>{conversationTitle}</b>. To rejoin, you’ll need to be added back by
    another member of the group.
  </div>
);

interface LeaveConversationModalProps {
  title: string;
  onClose: () => {};
  onConfirm: () => {};
  open?: () => {};
  loading?: Boolean;
}

const LeaveConversationModal = ({
  title,
  open,
  onClose,
  onConfirm,
}: LeaveConversationModalProps) => {
  const { palette } = useTheme();

  return (
    // @ts-ignore
    <Modal open={open} onClose={onClose} aria-labelledby="leave-chat-title">
      <Box
        role="dialog"
        aria-modal="true"
        aria-labelledby="leave-chat-title"
        sx={{
          position: 'absolute',
          top: {
            xs: '40%',
            sm: '50%',
          },
          left: {
            xs: '32px',
            sm: '50%',
          },
          right: {
            xs: '32px',
            sm: 'auto',
          },
          transform: {
            xs: 'none',
            sm: 'translate(-50%, -50%)',
          },
          width: {
            xs: 'auto',
            sm: '560px',
          },
          bgcolor: palette.background.paper,
          borderRadius: '8px',
          boxShadow: 24,
          padding: {
            xs: '24px 16px',
            sm: '24px 16px',
          },
          outline: 'none',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Text
            id="leave-chat-title"
            component="h2"
            tabIndex={0}
            sx={{
              fontWeight: 600,
              fontSize: '1.25rem',
              color: palette.text.primary,
              outline: 'none', // Remove focus outline since this is for screen readers
            }}
          >
            {INBOX_LEAVE_CONVERSATION_TITLE_RESPONSIVE}
          </Text>
          <IconButton
            onClick={onClose}
            size="small"
            aria-label="Close Leave Chat dialog"
            sx={{
              minWidth: 'auto',
              width: '24px',
              height: '24px',
              p: '5px',
            }}
          >
            <Icons.Close />
          </IconButton>
        </Box>

        {/* Content */}
        <Box sx={{ mt: '8px' }}>
          <Text mb={1.5} tabIndex={0}>
            {INBOX_LEAVE_CONVERSATION_QUESTION(title)}
          </Text>
          <Box>
            <Button
              fullWidth
              onClick={onConfirm}
              kind="primary"
              aria-label="Leave Chat"
              sx={{
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: palette.primary.dark,
                },
              }}
            >
              {INBOX_CONVERSATION_ACTION_LEAVE_CONVERSATION_RESPONSIVE}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default LeaveConversationModal;
